import { Component, Input, OnInit } from '@angular/core';
import { Atividade } from 'src/app/core/atividade';
import { Acesso } from '../../../../../core/acesso';
import { ComboIdDescricao } from '../../../../../core/combo-publico-alvo';
import { PublicoAlvoAtividade } from '../../../../../core/publico-alvo-atividade';
import { DataUtilService } from '../../../../../services/commons/data-util.service';
import { PublicoAlvoService } from '../../../../../services/publico-alvo/publico-alvo.service';
import { ToastService } from '../../../../../services/toast/toast.service';

@Component({
    selector: 'cadastrar-publico-alvo-atividade',
    templateUrl: './cadastrar-publico-alvo-atividade.component.html',
    styleUrls: ['./cadastrar-publico-alvo-atividade.component.css']
})
export class CadastrarPublicoAlvoAtividadeComponent implements OnInit {

    @Input() perfilAcesso: Acesso;

    @Input() oficina: Atividade;
    publicoAlvo: PublicoAlvoAtividade = new PublicoAlvoAtividade();

    isAtualizar = false;

    constructor(private toastService: ToastService,
        private dataUtilService: DataUtilService, 
        private publicoAlvoService: PublicoAlvoService) {
    }

    ngOnInit() {
        this.zerarCombos();
    }

    zerarCombos() {
        this.publicoAlvo = new PublicoAlvoAtividade();
    }

    adicionar() {
        const publicoAlvoAtividade = new PublicoAlvoAtividade();
        publicoAlvoAtividade.idPublicoAlvo = this.publicoAlvo.id;
        publicoAlvoAtividade.descricao = this.publicoAlvo.descricao;
        publicoAlvoAtividade.idAtividade = this.oficina.id;

        if (!this.oficina.publicosAlvosAtividade) {
            this.oficina.publicosAlvosAtividade = [];
        }

        if (this.oficina.publicosAlvosAtividade.some(pa => 
            pa.idPublicoAlvo === publicoAlvoAtividade.idPublicoAlvo && pa.idAtividade === publicoAlvoAtividade.idAtividade)) {
            this.toastService.showAlerta('Este público-alvo já foi adicionado para esta atividade.');
            return;
        }

        this.oficina.publicosAlvosAtividade.push(publicoAlvoAtividade);
        this.zerarCombos();
    }

    atualizar() {
        const index = this.oficina.publicosAlvosAtividade.indexOf(
            this.oficina.publicosAlvosAtividade.find(col => col.id === this.publicoAlvo.id));

        this.oficina.publicosAlvosAtividade.splice(index, 1, this.publicoAlvo);

        this.isAtualizar = false;
        this.zerarCombos();
    }

    atualizarPublicoAlvoAtividade(publicoAlvoAtividade: PublicoAlvoAtividade) {
        this.isAtualizar = true;
        this.publicoAlvo = publicoAlvoAtividade;
    }

    cancelar() {
        this.zerarCombos();
        this.isAtualizar = false;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    onDescricaoChangePublicoAlvo(event: ComboIdDescricao) {
        if (event) {
            this.carregarPublicoAlvo(event);
        } else {
            this.publicoAlvo = undefined;
        }
    }

    carregarPublicoAlvo(comboPublicoAlvoAtividade: ComboIdDescricao) {
        this.publicoAlvoService.getPublicoAlvoById(comboPublicoAlvoAtividade.id).subscribe((publicoAlvo: PublicoAlvoAtividade) => {
            this.publicoAlvo = publicoAlvo;
        })
    }
}
